import React, { useState } from "react";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Theme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { EExamInfoMenuItems, EExamInfoTabs } from "./HorseInfo/helper";
import Breakpoints from "common/breakpoints";
import HorseInfo from "./HorseInfo";
import Loader from "components/Loader";

import useStyles from "./styles";

interface IProps {
  horse: racehorse360.IHorse;
  workoutRequest: racehorse360.IWorkoutRequest;
  isShowHorseInfoDesktop: boolean;
  isShowHorseInfoMobile: boolean;
  onCloseHorseInfoMobile: () => void;
  completedExams: racehorse360.IHorseExam[];
}
export interface IScrollPositions {
  eidTabPosition: number;
  listsTabPosition: number;
  ppsTabPosition: number;
  worksTabPosition: number;
  scratchesTabPosition: number;
  generalInfoPosition: number;
  summaryPosition: number;
}

const HorseInfoContainer = (props: IProps) => {
  const {
    horse,
    workoutRequest,
    isShowHorseInfoDesktop,
    isShowHorseInfoMobile,
    onCloseHorseInfoMobile,
    completedExams
  } = props;
  const classes = useStyles();
  const matchesDownSM600 = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(Breakpoints.SM_600)
  );

  const [selectedMenuItem, setSelectedMenuItem] =
    useState<EExamInfoMenuItems>(null);
  const [selectedPerformanceTab, setSelectedPerformanceTab] =
    useState<EExamInfoTabs>(null);
  const [selectedHealthTab, setSelectedHealthTab] =
    useState<EExamInfoTabs>(null);
  const [tabPositions, setTabPositions] = useState<IScrollPositions>(null);

  if (matchesDownSM600 && isShowHorseInfoMobile) {
    return (
      <Dialog open={true} fullScreen onClose={onCloseHorseInfoMobile}>
        <DialogTitle className={classes.horseInfoMobileTitle}>
          <IconButton size={"small"} onClick={onCloseHorseInfoMobile}>
            <ArrowBackIcon className={classes.closeHorseInfoMobileIcon} />
          </IconButton>
          <span className={classes.titleText}>{`${horse.name} Info`}</span>
          <div className={classes.emptyBlock} />
        </DialogTitle>
        <DialogContent className={classes.horseInfoMobileContent}>
          <HorseInfo
            horse={horse}
            workoutRequest={workoutRequest}
            completedExams={completedExams}
            currentMenuItem={selectedMenuItem}
            onSetCurrentMenuItem={setSelectedMenuItem}
            currentPerformanceTab={selectedPerformanceTab}
            onSetCurrentPerformanceTab={setSelectedPerformanceTab}
            currentHealthTab={selectedHealthTab}
            onSetCurrentHealthTab={setSelectedHealthTab}
            tabPositions={tabPositions}
            onSetTabPosition={setTabPositions}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer
      className={classes.horseInfoDesktop}
      variant="persistent"
      anchor="right"
      open={!isShowHorseInfoDesktop}
    >
      {horse ? (
        <HorseInfo
          horse={horse}
          workoutRequest={workoutRequest}
          completedExams={completedExams}
          tabPositions={tabPositions}
          onSetTabPosition={setTabPositions}
        />
      ) : (
        <Loader />
      )}
    </Drawer>
  );
};

export default HorseInfoContainer;
